import SigliveServiceV2 from 'Service/sigliveServiceV2';

const getRole = async (queries = '') => {
  const { data } = await SigliveServiceV2({ method: 'GET', url: `/access/list-role?${queries}` });

  return data?.data;
};

export default getRole;
